import React from "react";
import Default from "./Partials";

const Show = () => {
    return (
        <Default />
    )
};

export default Show;